import { IconPropsType } from '..';

export const CheckIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <g id="kb-core-icon">
      <path
        id="Vector"
        d="M8.53554 1.5L3.93934 6.37868L1.46447 3.62132L0.403809 4.68198L3.93934 8.5L9.5962 2.56066L8.53554 1.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
